// @ts-nocheck
import { AlternatePackagingRequestModel } from "@store/Framework/Types/ApiModels";
import {
    SendAlternatePackagingRequestApiParameter,
    sendAlternativePackagingRequest,
} from "@store/Framework/Services/AlternatePackagingService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type SubmitRecommendedProductRequestParameter = {
    recommendedProductRequestModel: AlternatePackagingRequestModel;
    onSuccess?: () => void;
    onError?: () => void;
} & HasOnSuccess &
    HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<
    SubmitRecommendedProductRequestParameter,
    SendAlternatePackagingRequestApiParameter
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    await sendAlternativePackagingRequest(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitRecommendedProductRequestForm = createHandlerChainRunner(chain, "RecommendedProductRequestForm");
export default submitRecommendedProductRequestForm;
